const state = {
	investment_products: []
}

export default state



// WEBPACK FOOTER //
// ./src/common/store/Investment/state.js